import { render, staticRenderFns } from "./RuleEdit.vue?vue&type=template&id=a7450862&scoped=true"
import script from "./RuleEdit.vue?vue&type=script&lang=js"
export * from "./RuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7450862",
  null
  
)

export default component.exports